import { Component, OnInit, OnDestroy, computed, inject, effect, afterNextRender } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../../services/auth.service';
import { GeolocationService } from '../../../services/geolocation.service';
import { UserService } from '../../../services/user.service';
import { CoinsService } from '../../../services/coins.service';
import { SHARED_IMPORTS } from '../../../shared/shared-imports';
import { Wallet } from 'lucide-angular';
import { RegaloService } from '../../../services/regalos.service';
import { PresenceService } from '../../../services/presence.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [SHARED_IMPORTS],
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})
export class AppLayoutComponent implements OnInit, OnDestroy {
  menuItems: MenuItem[] = [];
  readonly Wallet = Wallet;

  private userService = inject(UserService);
  private coinsService = inject(CoinsService);
  private regalosService = inject(RegaloService);
  private auth = inject(AuthService);
  private router = inject(Router);
  private geo = inject(GeolocationService);
  private presence = inject(PresenceService);

  usuario = computed(() => this.userService.usuarioSignal());
  coins$ = this.coinsService.getBalance();
  regalosRecibidosNoVistos = this.regalosService.regalosRecibidosNoVistos;

  pantallaPequena = window.innerWidth < 768;
  ultimaCantidadCoins = 0;

  constructor() {
    afterNextRender(() => {
      this.auth.onAuthStateChanged(() => {
        this.presence.listenOnlineUsers();
      });
    });
    effect(() => {
      this.actualizarMenu();
    });
  }


  ngOnInit(): void {
    this.geo.startTracking();
    window.addEventListener('resize', this.verificarPantalla);
    this.verificarPantalla();

    // Suscripción a cambios de coins
    this.coins$.subscribe(coins => {
      this.ultimaCantidadCoins = coins || 0;
      this.actualizarMenu();
    });

    // Efecto reactivo para cambios en usuario
    
  }

  ngOnDestroy(): void {
    this.geo.stopTracking();
    window.removeEventListener('resize', this.verificarPantalla);
  }

  verificarPantalla = () => {
    const esPequena = window.innerWidth < 768;
    if (this.pantallaPequena !== esPequena) {
      this.pantallaPequena = esPequena;
      this.actualizarMenu();
    }
  };

  async logout(): Promise<void> {
    await this.auth.logout();
    this.router.navigateByUrl('/auth');
  }

  actualizarMenu(): void {
    const base: MenuItem[] = [
      { label: 'Perfil', icon: 'pi pi-user', routerLink: '/app/mi-perfil' },
      { label: 'Buscar', icon: 'pi pi-search', routerLink: '/app/buscar' },
      { label: 'Favs', icon: 'pi pi-star', routerLink: '/app/fav' },
      { label: 'Bloqueados', icon: 'pi pi-ban', routerLink: '/app/bloqueados' },
      { label: 'Configuración', icon: 'pi pi-cog', routerLink: '/app/configuracion' },
    ];

    if (this.pantallaPequena) {
      base.push(
        {
          label: `Coins: ${this.ultimaCantidadCoins}`,
          icon: 'pi pi-wallet',
          routerLink: '/app/tienda',
        },
        {
          label: `Regalos (${this.regalosRecibidosNoVistos().length})`,
          icon: 'pi pi-gift',
          routerLink: '/app/regalos-recibidos',
        },
        {
          label: 'Cerrar sesión',
          icon: 'pi pi-sign-out',
          command: () => this.logout(),
        }
      );
    }

    // Agregar menú admin si aplica
    const user = this.usuario();
    if (user?.role === 'admin') {
      const yaExiste = base.some(item => item.label === 'Admin');
      if (!yaExiste) {
        base.push({
          label: 'Admin',
          icon: 'pi pi-shield',
          items: [
            { label: 'Dashboard', icon: 'pi pi-chart-bar', routerLink: '/admin' },
            { label: 'Usuarios', icon: 'pi pi-users', routerLink: '/admin/usuarios' },
            { label: 'Regalos', icon: 'pi pi-gift', routerLink: '/admin/regalos' },
            { label: 'Reportes', icon: 'pi pi-file', routerLink: '/admin/reportes' },
            { label: 'Monetización', icon: 'pi pi-dollar', routerLink: '/admin/packagemanager' },
            { label: 'Solicitudes de Cobro', icon: 'pi pi-money-bill', routerLink: '/admin/solicitudes-cobro' }
          ]
        });
      }
    }

    this.menuItems = base;
  }
}
